<template>
  <details class="mp-used" data-testid="monitoring_points_used_by_other_places">
    <summary class="mp-used__summary">
      {{ $mpt($t('field.used_by_other_places')) }}
      <span
        class="mp-used__count"
        data-testid="used_monitoring_point_count"
      >{{ $t('field.count', { count: rows.length }) }}</span>
    </summary>
    <div class="mp-used__list">
      <div
        v-for="row in rows"
        :key="row.id"
        class="mp-used__row"
        data-testid="used_monitoring_point_row"
      >
        <span class="mp-used__type">{{ row.typeName }}</span>
        <span class="mp-used__main min-w-0">
          <span
            class="mp-used__name text-truncate min-w-0"
            :title="row.name"
            data-testid="used_monitoring_point_name"
          >{{ row.name }}</span>
          <span
            v-if="row.place"
            class="mp-used__place text-truncate min-w-0"
            :title="row.place"
            data-testid="used_monitoring_point_place"
          >{{ row.place }}</span>
        </span>
        <span
          class="mp-used__assigned text-truncate min-w-0"
          :title="row.assignedToPlace"
          data-testid="used_monitoring_point_assigned_place"
        >{{ row.assignedToPlace }}</span>
      </div>
    </div>
  </details>
</template>

<i18n lang="yaml">
ja:
  field:
    used_by_other_places: 他の施設で利用中のセンサー
    count: '{count}件'
en:
  field:
    used_by_other_places: Sensors used by other facilities
    count: '{count}'
</i18n>

<script>
import SensorTypes from '@/mixins/sensorTypes';
import { buildSensorSections } from '@/libs/sensorSections';

export default {
  name: 'monitoring-points-used-by-other-places',
  mixins: [SensorTypes],
  props: {
    sensors: { type: Array, default: () => [] },
  },
  computed: {
    // 種別ごとの並び順は選択欄と揃える。見出しは出さず、種別名を行の列に出す
    rows() {
      return buildSensorSections(this.sensors, { typeNames: this.SENSOR_TYPE_NAMES })
        .flatMap(section => section.sensors.map(sensor => ({ ...sensor, typeName: section.label })));
    },
  },
};
</script>

<style scoped lang="sass">
.mp-used
  border: 1px solid #e0e0e0
  border-radius: 4px
  margin-top: 12px

// 見出しと件数を左右に振り分ける。枠線との間に余白を取る
.mp-used__summary
  display: flex
  align-items: center
  gap: 8px
  padding: 10px 12px
  cursor: pointer
  font-size: 12px
  font-weight: 500
  color: #757575
  // display: flex にすると既定の三角が出なくなるため、開閉の向きごと自前で描く
  list-style: none

  &::-webkit-details-marker
    display: none

  &::before
    content: ''
    flex-shrink: 0
    width: 0
    height: 0
    border-left: 5px solid #9aa0a6
    border-top: 4px solid transparent
    border-bottom: 4px solid transparent
    transition: transform 0.15s ease

.mp-used[open] > .mp-used__summary::before
  transform: rotate(90deg)

.mp-used__count
  margin-left: auto
  font-size: 11px
  font-weight: 400
  color: #9aa0a6

.mp-used__list
  border-top: 1px solid #e0e0e0
  max-height: 168px
  overflow-y: auto

// 列を縦に通すため行は flex。可変長テキストの ellipsis を効かせるには
// flex 子要素の min-width を 0 にする必要がある
.mp-used__row
  display: flex
  align-items: center
  gap: 12px
  padding: 8px 12px

.mp-used__row + .mp-used__row
  border-top: 1px solid #f2f3f4

.mp-used__type
  width: 72px
  flex-shrink: 0
  font-size: 11px
  color: #9aa0a6

.mp-used__name
  font-size: 13px
  color: #3c4043

.mp-used__place
  font-size: 11px
  color: #9aa0a6

// 設置場所名が無い行でも高さを揃える。揃っていないと列として読めない
.mp-used__main
  display: flex
  flex-direction: column
  justify-content: center
  gap: 2px
  width: 180px
  flex-shrink: 0
  min-height: 39px

.mp-used__assigned
  margin-left: auto
  width: 180px
  flex-shrink: 0
  font-size: 11px
  color: #9aa0a6

// 幅が足りない画面では列を保てないため、行の中で縦に積む
@media (max-width: 599px)
  .mp-used__row
    flex-wrap: wrap
    row-gap: 2px

  .mp-used__main,
  .mp-used__assigned
    width: auto
    flex: 1 1 100%
    margin-left: 0

  .mp-used__main
    min-height: 0
</style>
